import AppRoutes from "../AppRoutes";
import { useContext, useEffect, useRef, useState } from "react";
import axiosInstance from '../axiosConfig';
import { UserDetailsContext } from "../Context/userDetailsContext";
import { Box, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";

const MainApp = () => {
    const [loadApp, setLoadApp] = useState(true);
    const { userDetails, setUserDetails } = useContext(UserDetailsContext);
    const { i18n } = useTranslation();
    const lastFetchedLangRef = useRef(null);

    useEffect(() => {
        const currentLang = i18n.language?.startsWith("en") ? "en" : "ar";
        if (lastFetchedLangRef.current === currentLang && userDetails?.isAuthenticated !== undefined) {
            return;
        }
        lastFetchedLangRef.current = currentLang;

        axiosInstance.get("/User/Info").then(userInfo => {
            setUserDetails({ ...(userInfo || {}), isAuthenticated: true });
        }).catch(() => {
            setUserDetails({ isAuthenticated: false });
        }).finally(() => {
            setLoadApp(false);
        });
    }, [i18n.language, setUserDetails]);

    if (loadApp) {
        return (
            <Box sx={{ mt: 25, textAlign: "center" }}>
                <CircularProgress size={80} />
            </Box>
        );
    }

    return <AppRoutes />;
};

export default MainApp;
